import React from "react"
import PropTypes from "prop-types"

const Tab = ({ data, id, selected, onClick, ...rest }) => (
  <button
    type="button"
    name="Tab"
    onClick={() => onClick(id)}
    style={{ flex: 1 }}
    className={`dashboard-widget-layout-tab${
      selected ? " dashboard-widget-layout-tab-selected" : ""
    }`}
    {...rest}
  >
    {data.title}
  </button>
)

Tab.propTypes = {
  data: PropTypes.object.isRequired,
  id: PropTypes.any.isRequired,
  selected: PropTypes.bool,
  onClick: PropTypes.func.isRequired
}

Tab.defaultProps = {
  selected: false
}

export default Tab
